module.exports = __webpack_public_path__ + "static/media/blog4.2cb310db.png";